import { Flex } from '@lokalise/louis';

import { Link } from '../components';
import { ClientName } from './styles';
import useEmailClients from './useEmailClients';

const OpenEmailClientLinks = () => {
    const [emailClients, { isLoading }] = useEmailClients();

    return (
        <Flex gap={8}>
            {!isLoading &&
                emailClients.map(({ id, openText, link, icon }) => (
                    <Link aria-label={openText} key={id} onClick={() => window.open(link, '_blank')}>
                        <Flex align="center">
                            {icon}
                            <ClientName>{openText}</ClientName>
                        </Flex>
                    </Link>
                ))}
        </Flex>
    );
};

export default OpenEmailClientLinks;
